//import { LineEqualSymbol } from "../../../../../../../../src/types/Enum";
import { DrawingTool } from "../../../../types/Enum"


const ANSWER_COLOR = 0x21D4FE

export function getLineType(tool: DrawingTool, color: number) {
  switch (tool) {
    /*  case DrawingTool.doubleLine: return {
        color: 0xCCCCCC,
        width: 10,
        isEqualSymbol: false
      };*/
    /* case DrawingTool.lineWithDirSym: return {
       color: 0xFF0000,
       width: 5,
       isEqualSymbol: true,
       equalSymbol: LineEqualSymbol.Arrow
     };*/
    case DrawingTool.answerLine: return {
      color: ANSWER_COLOR,
      width: 8,
      isEqualSymbol: false
    };
    default: return {
      color,
      width: 5,
      isEqualSymbol: false
    };
  }
}


export function getPointColor(tool: DrawingTool): number {
  switch (tool) {
    case DrawingTool.answerPoint: return ANSWER_COLOR;
    default: return 0x000000;
  }
}